export default {
  online_product: {
    setting: false,
    name: [
      {
        title: '业务规则',
        content: '所选日期有消耗的产品数'
      }
    ],
    rate: [
      {
        title: '业务规则',
        content: '计算环比'
      },
      {
        title: '计算公式',
        content: `
          上周期：从所选开始日期往前一天，到往前推所选日期到结束日期的天数
          <br /><br />
          ((本周期在线产品数-上周期在线产品数)/上周期在线产品数)*100%
        `
      }
    ],
    cost: [
      {
        title: '业务规则',
        content: '计算所选日期的消耗额'
      },
      {
        title: '计算公式',
        content: '所选日期内的总消耗'
      }
    ]
  },

  direct_product: {
    setting: false,
    name: [
      {
        title: '业务规则',
        content: `
          首次消耗在所选日期范围的产品数
        `
      }
    ],
    rate: [
      {
        title: '业务规则',
        content: '计算环比'
      },
      {
        title: '计算公式',
        content: `
          上周期：从所选开始日期往前一天，到往前推所选日期到结束日期的天数
          <br /><br />
          ((本周期在线产品数-上周期在线产品数)/上周期在线产品数)*100%
        `
      }
    ],
    cost: [
      {
        title: '业务规则',
        content: '计算所选日期的消耗额'
      },
      {
        title: '计算公式',
        content: '所选日期内的总消耗'
      }
    ]
  },

  channel_product: {
    setting: false,
    name: [
      {
        title: '业务规则',
        content: '首次消耗在所选日期范围的产品数'
      },
      {
        title: '计算公式',
        content: `
          渠道销售维度：所负责的代理商首次新开的产品数（每个代理算1次）
          <br /><br />
          运营维度：公司所有代理商首次新开的产品数
        `
      }
    ],
    rate: [
      {
        title: '业务规则',
        content: '计算环比'
      },
      {
        title: '计算公式',
        content: `
          上周期：从所选开始日期往前一天，到往前推所选日期到结束日期的天数
          <br /><br />
          ((本周期在线产品数-上周期在线产品数)/上周期在线产品数)*100%
        `
      }
    ],
    cost: [
      {
        title: '业务规则',
        content: '计算所选日期的消耗额'
      },
      {
        title: '计算公式',
        content: '所选日期内的总消耗'
      }
    ]
  },

  stop_product: {
    setting: true,
    name: [
      {
        title: '业务规则',
        content: '所选日期内，X天没有消耗的产品'
      }
    ],
    rate: [
      {
        title: '业务规则',
        content: '计算环比'
      },
      {
        title: '计算公式',
        content: `
          上周期：从所选开始日期往前一天，到往前推所选日期到结束日期的天数
          <br /><br />
          ((本周期在线产品数-上周期在线产品数)/上周期在线产品数)*100%
        `
      }
    ],
    cost: [
      {
        title: '业务规则',
        content: '计算所选日期的消耗额'
      },
      {
        title: '计算公式',
        content: '所选日期内的总消耗'
      }
    ]
  }
};
